import type { IconProps } from '../types/IconProps.ts';
export const Hammer: IconProps = {
    name: 'Hammer',
    children: [
        `<path d="m12.5 7.5-8.15 9a2.12 2.12 0 0 0 3.15 2.85L16 10" />`,
        `<path d="m19.6 11.88-2.5-1.97a.8.8 0 0 0-1.07.07.8.8 0 0 1-1.1.04l-2.3-1.99a.76.76 0 0 1-.05-1.11c.25-.25.3-.64.05-.88-1.2-1.18-3.84-1.63-5.58-2.33q0 0 0 0c5.97-3.43 9.4-.31 11.08 1.8.2.26.12.63-.17.8a.27.27 0 0 0-.04.44l3.58 2.91M18.7 13 22 9" />`,
    ]
};